import * as Sentry from '@sentry/react';
import User from 'types/User';

// We only want to run this once per session
let loggedIn = false;

export const thirdPartyLogin = (user: User) => {
  if (loggedIn) return;
  loggedIn = true;
  sentry(user);
  appcues(user);
  fullstory(user);
};

export const thirdPartyLogOut = () => {
  loggedIn = false;

  const Appcues = (window as any)['Appcues'];
  if (Appcues) {
    Appcues.reset();
  }
};

function sentry(user: User) {
  if (import.meta.env.REACT_APP_ENABLE_SENTRY === 'true') {
    Sentry.setUser({
      id: user.id.toString(),
      username: user.name,
    });

    const currentAccount = user.currentAccount;
    if (currentAccount) {
      Sentry.setTag('ugc_account.id', currentAccount.id);
      Sentry.setTag('ugc_account.name', currentAccount.name);
      Sentry.setTag('ugc_account.brand', currentAccount.brand);
    }
  }
}

function appcues(user: User) {
  const Appcues = (window as any)['Appcues'];
  if (!Appcues) return;

  const currentAccount = user.currentAccount;
  Appcues.identify(user.id, userProperties(user));

  if (currentAccount) {
    Appcues.group(`ugc-${currentAccount.id}-${currentAccount.brand}`, {
      name: currentAccount.name,
      brand: currentAccount.brand,
      createdAt: currentAccount.createdAtIso8601,
    });
  }
}

function fullstory(user: User) {
  const FS = (window as any)['FS'];
  if (!FS) return;

  FS('setIdentity', {
    uid: user.id,
    properties: userProperties(user),
  });
}

function userProperties(user: User) {
  const currentAccount = user.currentAccount;

  return {
    email: user.email,
    firstName: user.firstName,
    lastName: user.lastName,
    accountName: currentAccount?.name,
    accountId: currentAccount?.id,
    accountBrand: currentAccount?.brand,
    createdAt: user.createdAtIso8601,
  };
}
